import { RouteObject } from "react-router-dom";
import RelatorioSistemaView from "./RelatorioSistema.View";
import RelatorioSistemaCadastroView from "./Cadastro/RelatorioSistemaCadastro.View";

export const RelatorioRoutes: RouteObject[] = [
  {
    path: "relatorio/sistema",
    element: <RelatorioSistemaView />,
  },
  {
    path: "relatorio/sistema/cadastro",
    element: <RelatorioSistemaCadastroView />,
  },
];
